<template>
  <div class="gestione_aziende" style="margin: 20px">
    <v-card>
      <v-toolbar dense color="indigo" dark align="center">
        <v-row class="mt-4">
          <v-col cols="3" class="mt-1" align="left">
            <v-toolbar-title>Gestione Aziende</v-toolbar-title>
          </v-col>
          <v-col cols="3" align="left">
            <v-text-field
              v-model="filter"
              solo
              dense
              append-icon="mdi-magnify"
              clearable
              light
              placeholder="Ricerca per ragione sociale"
            ></v-text-field>
          </v-col>
          <v-col class="mt-1" cols="1">
            <v-btn small light @click="setAziende">
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </v-col>
          <v-col class="mt-1" cols="1">
            <v-btn small light @click="mostraDialog(null)">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col class="mt-1" cols="3" align="right">
            <v-btn small light @click="getAziende">
              <v-icon color="primary">mdi-autorenew</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" class="mt-1" align="right">
            <v-btn small light @click="$router.push('/home/amministrazione')">
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container>
        <v-data-table
          :key="render"
          :headers="tabella.testata"
          :items="filtraAziende(filter)"
          class="gestione_aziende"
        >
          <!-- BOTTONE MODIFICA -->
          <template v-slot:[`item.modifica_btn`]="{ item }">
            <v-btn
              small
              :disabled="item.validita != 1"
              @click="mostraDialog(item)"
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.crea_db_btn`]="{ item }">
            <v-btn
              small
              :disabled="item.existing_db == 1 || item.id_azienda == -1"
              @click="dialogCreazioneDB(item)"
            >
              <v-icon color="success">mdi-database-plus</v-icon>
            </v-btn>
          </template>

          <!-- Bottone per attivare i DBS -->
          <template v-slot:[`item.attiva_dbs`]="{ item }">
            <v-btn
              small
              :disabled="
                item.existing_db == null ||
                item.existing_db == 0 ||
                item.id_azienda == -1 ||
                (item.admin_password != null && item.admin_password != '')
              "
              @click="clickAttivaDBS(item)"
            >
              <v-icon color="primary"> mdi-database-lock </v-icon>
            </v-btn>
          </template>

          <!-- BOTTONE VALIDITA -->
          <template v-slot:[`item.rimuovi_btn`]="{ item }">
            <v-btn small @click="toggleValidita(item)">
              <v-icon :color="item.validita == 1 ? 'error' : 'primary'">{{
                item.validita == 1 ? "mdi-close" : "mdi-restore"
              }}</v-icon>
            </v-btn>
          </template>
          <!-- IMMAGINE -->
          <template v-slot:[`item.img_azienda`]="{ item }">
            <v-icon v-if="item.img_azienda == null">mdi-image-off</v-icon>
            <v-img
              style="margin: 0 auto; display: block"
              max-width="24"
              v-if="item.img_azienda != null"
              :src="item.img_azienda"
            />
          </template>
          <!-- COLONNA ATTIVO -->
          <template v-slot:[`item.attivo`]="{ item }">
            <v-icon :color="item.attivo == 1 ? 'success' : 'error'">{{
              item.attivo == 1 ? "mdi-check" : "mdi-close"
            }}</v-icon>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
    <v-dialog persistent v-model="dialog.mostra">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-row align="center" dark>
            <v-col cols="5" align="left">
              <v-toolbar-title>Modifica Azienda</v-toolbar-title>
            </v-col>
            <v-col cols="2">
              <v-btn small light @click="salvaDialog">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5" align="right">
              <v-btn small light @click="dialog.mostra = false">
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-container>
          <v-form ref="form">
            <v-row align="center">
              <v-col cols="3">
                <v-text-field
                  label="Ragione Sociale"
                  v-model="dialog.buffer.ragione_sociale"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Partita IVA"
                  v-model="dialog.buffer.partita_iva"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Nome Database"
                  v-model="dialog.buffer.nome_database"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Sottodominio"
                  v-model="dialog.buffer.sottodominio"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="2">
                <v-text-field
                  label="Prefisso Utente"
                  v-model="dialog.buffer.prefisso_utente"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Codice Azienda"
                  v-model="dialog.buffer.cod_azienda"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  type="number"
                  min="0"
                  label="ID Azienda Rif."
                  v-model="dialog.buffer.id_azienda_rif"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  type="number"
                  min="0"
                  label="ID Agente"
                  v-model="dialog.buffer.id_agente"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Codice ISO"
                  v-model="dialog.buffer.cod_iso"
                />
              </v-col>
              <v-col cols="2">
                <v-checkbox label="Attivo" v-model="dialog.buffer.attivo" />
              </v-col>
            </v-row>
            <v-divider />
            <v-row align="center">
              <v-col cols="4">
                <v-text-field label="Titolo" v-model="dialog.buffer.titolo" />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Versione Software"
                  v-model="dialog.buffer.sw_ver"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field label="Licenza" v-model="dialog.buffer.license" />
              </v-col>
            </v-row>
            <v-divider />
            <v-row align="center">
              <v-col cols="4">
                <v-textarea
                  no-resize
                  rows="3"
                  label="Testo Azienda"
                  v-model="dialog.buffer.testo_azienda"
                />
              </v-col>
              <v-col cols="4">
                <v-textarea
                  no-resize
                  rows="3"
                  label="Testo Privacy"
                  v-model="dialog.buffer.testo_privacy"
                />
              </v-col>
              <v-col cols="4">
                <v-textarea
                  no-resize
                  rows="3"
                  label="Testo Termini Uso"
                  v-model="dialog.buffer.testo_termini_uso"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row v-if="dialog.buffer.img_azienda != null" align="center">
              <v-col cols="1" />
              <v-col cols="5" align="right">
                <v-img :src="dialog.buffer.img_azienda" max-width="250" />
              </v-col>
              <v-col cols="5" align="left">
                <v-row>
                  <v-btn
                    width="200"
                    class="mb-10"
                    @click="dialog.buffer.img_azienda = null"
                    >Rimuovi Immagine</v-btn
                  >
                </v-row>
                <v-row>
                  <v-btn width="200" color="primary" @click="uploadAndCompress"
                    >Cambia Immagine</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" v-if="dialog.buffer.img_azienda == null">
              <v-col cols="12">
                <v-btn
                  class="mt-2"
                  width="200"
                  text
                  color="primary"
                  @click="uploadAndCompress"
                  >Carica Immagine Azienda</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog per la creazione del DB -->
    <v-dialog v-model="mostra_db" width="600">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>
            Creazione DataBase per il cliente <b>{{ cliente }}</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small @click="mostra_db = false">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <span style="font-size: 18px">
            Sei sicuro di voler creare il database per l'azienda selezionata?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="creaDBCliente" color="success"> CREA</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_conferma_dbs" width="700">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row dense>
            <v-col cols="4" align="left">
              <v-toolbar-title class="white--text">
                Attivazione DBS
              </v-toolbar-title>
            </v-col>
            <v-col cols="4">
              <v-btn @click="makeAdmin" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4" align="right">
              <v-btn @click="chiudiConfermaDBS" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-container class="mt-5" fluid>
            <v-row dense>
              <v-col cols="12">
                <span style="font-size: 18px">
                  Questa procedura genererà il DB secure abbinato a
                  {{ db_sel }}. Per confermare l'attivazione di questa
                  funzionalità, indicare lo username e la password attuale
                  dell'utente a cui garantire accesso ai dati.
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  dense
                  label="Username"
                  outlined
                  style="border-radius: 0px"
                  v-model="username_sel"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  label="Password"
                  outlined
                  style="border-radius: 0px"
                  :type="show_pwd_dbs ? 'text' : 'password'"
                  v-model="password_sel"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="show_pwd_dbs = !show_pwd_dbs"
                      color="dark-grey"
                    >
                      {{ show_pwd_dbs ? "mdi-eye" : "mdi-eye-off" }}
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar di avviso -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "GestioneAziende",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      caricamento: false,
      db_sel: "",
      password_sel: "",
      username_sel: "",
      filter: null,
      render: 0,
      show_pwd_dbs: false,
      dialog: {
        buffer: {
          id_azienda: null,
          id_azienda_rif: null, //
          id_agente: null, //
          attivo: null, //
          ragione_sociale: null, //
          prefisso_utente: null, //
          nome_database: null, //
          cod_azienda: null, //
          cod_iso: null, //
          partita_iva: null, //
          license: null, //
          sw_ver: null, //
          testo_azienda: null,
          titolo: null, //
          testo_privacy: null,
          testo_termini_uso: null,
          img_azienda: null,
          existing_db: 0,
          validita: 1,
          sottodominio: null,
        },
        indice: -1,
        mostra: false,
      },
      dialog_conferma_dbs: false,
      mostra_db: false,
      azienda_sel: null,
      cliente: null,
      tabella: {
        testata: [
          {
            text: "Modifica",
            value: "modifica_btn",
            sortable: false,
            align: "left",
          },
          {
            text: "Crea DB",
            value: "crea_db_btn",
            sortable: false,
            align: "left",
          },
          { value: "id_azienda_rif", text: "ID Azienda Rif." },
          { value: "id_agente", text: "ID Agente" },
          { value: "attivo", text: "Attivo" },
          { value: "ragione_sociale", text: "Ragione Sociale" },
          { value: "prefisso_utente", text: "Prefisso Utente" },
          { value: "nome_database", text: "Nome DB" },
          { value: "cod_azienda", text: "Codice Azienda" },
          { value: "img_azienda", text: "Immagine Azienda", align: "center" },
          { value: "cod_iso", text: "Codice ISO" },
          { value: "partita_iva", text: "Partita IVA" },
          { value: "license", text: "Licenza" },
          { value: "sw_ver", text: "Versione Software" },
          { value: "testo_azienda", text: "Testo Azienda" },
          { value: "titolo", text: "Titolo" },
          { value: "testo_privacy", text: "Testo Privacy" },
          { value: "testo_termini_uso", text: "Testo Termini Uso" },
          { text: null, value: "rimuovi_btn", sortable: false, align: "right" },
        ],
        dati: [],
      },
    };
  },
  mounted() {
    this.getAziende();
    this.getUtenteAttuale();
  },
  methods: {
    chiudiConfermaDBS() {
      this.db_sel = "";
      this.username_sel = "";
      this.password_sel = "";
      this.dialog_conferma_dbs = false;
    },
    clickAttivaDBS(arg) {
      this.db_sel = arg.nome_database;
      this.username_sel = "";
      this.password_sel = "";
      this.dialog_conferma_dbs = true;
    },
    async getUtenteAttuale() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getutenteattuale",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status == 200) {
            // Se è un amministratore, gli faccio vedere le colonne riservate.
            if (
              res.data.result.is_admin == 1 &&
              res.data.result.database == "db_piusviluppo"
            ) {
              // Aggiungo il bottone per nominare un amministratore.
              this.tabella.testata.splice(2, 0, {
                text: "Attiva DBS",
                value: "attiva_dbs",
                sortable: false,
                align: "left",
              });
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i privilegi di questo utente."
            );
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i privilegi di questo utente."
          );
          return false;
        });
    },
    filtraAziende(filter) {
      if ((filter || "").trim() == "") {
        return this.tabella.dati;
      }
      const result = new Array();
      this.tabella.dati.forEach((device) => {
        if (
          (device.ragione_sociale || "")
            .toLowerCase()
            .indexOf(filter.toLowerCase().trim()) >= 0
        ) {
          result.push(device);
        }
      });
      return result;
    },
    makeAdmin() {
      let request = {
        controller: "secure",
        method: "PUT",
        richiesta: {
          action: "makeadmin",
          token: localStorage.getItem("user_token"),
          db: this.db_sel,
          username: this.username_sel,
          password: this.password_sel,
        },
      };

      this.dialog_conferma_dbs = false;
      this.caricamento = true;
      return this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status == 200) {
            this.getAziende();
            this.$refs.SnackbarQV.print(
              "success",
              "Privilegi gestiti con successo."
            );
            this.username_sel = "";
            this.password_sel = "";
            this.db_sel = "";
            this.caricamento = false;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Non è stato possibile modificare i privilegi di accesso."
            );
            this.caricamento = false;
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile modificare i privilegi di accesso."
          );
          this.caricamento = false;
          return false;
        });
    },
    creaDBCliente() {
      let request = {
        controller: "Modulo",
        method: "PUT",
        richiesta: {
          action: "creadbcliente",
          token: localStorage.user_token,
          azienda: [this.azienda_sel],
        },
      };

      this.mostra_db = false;
      this.caricamento = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento = false;
          if (res.status === 200) {
            this.getAziende();
            this.$refs.SnackbarQV.print(
              "success",
              "Database cliente creato con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore durante la creazione del database."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore durante la creazione del database."
          );
        });
    },
    dialogCreazioneDB(item) {
      this.cliente = item.ragione_sociale;
      this.azienda_sel = Object.assign({}, item);
      console.log("azienda sel:", item);
      this.mostra_db = true;
    },
    toggleValidita(riga) {
      riga.validita = riga.validita == 0 ? 1 : 0;
    },
    getAziende() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getAzienda",
          token: localStorage.user_token,
        },
      };

      this.caricamento = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento = false;
          if (res.status == 200) {
            this.tabella.dati = res.data.result.azienda;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.caricamento = false;
        });
    },
    mostraDialog(riga) {
      this.dialog.mostra = true;
      let indice = this.tabella.dati.indexOf(riga);
      this.dialog.indice = indice;
      let campi = Object.keys(this.dialog.buffer);
      for (let i = 0; i < campi.length; i++) {
        this.dialog.buffer[campi[i]] = indice < 0 ? null : riga[campi[i]];
        if (campi[i] == "attivo" && indice >= 0) {
          this.dialog.buffer[campi[i]] = riga[campi[i]] == 1;
        }
      }
      let that = this;
      this.$nextTick(function () {
        that.$refs.form.resetValidation();
      });
    },
    salvaDialog() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.dialog.indice < 0) {
        let clone = Object.assign({}, this.dialog.buffer);
        clone.validita = 1;
        clone.id_azienda = -1;
        clone.attivo = clone.attivo == 1 ? 1 : 0;
        clone.id_personale = -1;
        this.tabella.dati.push(clone);
      } else {
        let campi = Object.keys(this.dialog.buffer);
        for (let i = 0; i < campi.length; i++) {
          this.tabella.dati[this.dialog.indice][campi[i]] =
            this.dialog.buffer[campi[i]];
          if (campi[i] == "attivo") {
            this.tabella.dati[this.dialog.indice][campi[i]] =
              this.dialog.buffer[campi[i]] == true ? 1 : 0;
          }
        }
      }
      this.dialog.mostra = false;
    },

    setAziende() {
      let request = {
        controller: "Modulo",
        method: "PUT",
        richiesta: {
          action: "setAzienda",
          token: localStorage.user_token,
          azienda: this.tabella.dati,
        },
      };

      this.caricamento = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento = false;
          if (res.status == 200) {
            this.getAziende();
            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore durante il salvataggio."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore durante il salvataggio."
          );
        });
    },
    deleteToggle(index) {
      if (this.aziende[index].validita == 0) {
        this.aziende[index].validita = 1;
      } else {
        if (this.aziende[index].id_azienda == -1) {
          this.aziende.splice(index, 1);
          return;
        }
        this.aziende[index].validita = 0;
      }
    },
    showDialog(index_sel, field_sel, field_type) {
      this.selected = { index: index_sel, field: field_sel, type: field_type };
      this.dialog.show = true;
    },
    uploadAndCompress() {
      let that = this;
      let input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/png, image/jpeg");
      input.onchange = function () {
        let reader = new FileReader();
        reader.onload = function () {
          let img = new Image();
          img.onload = function () {
            let width, height;
            let ratio = img.width / img.height;
            if (img.width > img.height) {
              width = Math.min(500, img.width);
              height = width / ratio;
            } else {
              height = Math.min(500, img.height);
              width = height * ratio;
            }
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            that.dialog.buffer.img_azienda = ctx.canvas.toDataURL();

            canvas = null;
            img = null;
            reader = null;
            input = null;
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(input.files[0]);
      };
      input.click();
    },
  },
};
</script>
<style >
.gestione_aziende th,
.gestione_aziende td {
  max-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>